import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-exam-loading',
  templateUrl: './exam-loading.component.html',
  styleUrls: ['./exam-loading.component.scss']
})
export class ExamLoadingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  

}
